import {NgZone} from '@angular/core';
import {RouterHistory} from '@tanstack/react-router';
import {BaseLocationServices, UIRouter} from '@uirouter/core';
import {stripBasePath, withBasePath} from '../history/history';

export class TanStackLocationServices extends BaseLocationServices {
  private writing = false;
  private readonly unsubscribe: () => void;

  constructor(router: UIRouter, private readonly history: RouterHistory, ngZone: NgZone) {
    super(router, true);
    this.unsubscribe = history.subscribe(({action}) => {
      if (this.writing) {
        return;
      }
      ngZone.run(() => this._listener({type: action.type}));
    });
  }

  protected _get(): string {
    return stripBasePath(this.history.location.href);
  }

  protected _set(state: unknown, _title: string, url: string, replace: boolean): void {
    const href = withBasePath(url);
    this.writing = true;
    try {
      if (replace) {
        this.history.replace(href, state);
      } else {
        this.history.push(href, state);
      }
    } finally {
      this.writing = false;
    }
  }

  dispose(router: UIRouter): void {
    this.unsubscribe();
    super.dispose(router);
  }
}
